import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

export default {
  props: {
    formConfig: {
      type: Object,
      default: function _default() {}
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  components: {},
  data: function data() {
    var _this = this;

    var validateName = function validateName(rule, value, callback) {
      var regular = /^[0-9a-zA-Z_]{1,}$/;
      if (!regular.test(value)) {
        callback(new Error(_this.$t('playTurbo.common.createVersionDialog.form.name.format')));
      } else {
        callback();
      }
    };
    return {
      formValue: {
        name: ''
      },
      loading: true,
      rules: {
        name: [{
          required: true,
          message: this.$t('playTurbo.common.createVersionDialog.form.name.required'),
          trigger: 'change'
        }, {
          min: 1,
          max: 50,
          message: this.$t('playTurbo.common.createVersionDialog.form.name.length'),
          trigger: 'blur'
        }, { required: true, validator: validateName, trigger: 'blur' }]
      }
    };
  },

  computed: {
    innerTitle: function innerTitle() {
      return this.config.title || this.$t('playTurbo.common.createVersionDialog.title');
    }
  },
  methods: {
    setName: function setName() {
      this.formValue.name = 'project' + this.config.total;
      this.loading = false;
    },
    submitDialog: function submitDialog() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$refs.form.validate(function (valid) {
                  if (valid) {
                    _this2.createVersion();
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    createVersion: function createVersion() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var postdata;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                try {
                  postdata = _extends({
                    template_id: _this3.config.template_id
                  }, _this3.formValue);

                  if (_this3.config.copy_id) {
                    postdata.custom_id = _this3.config.copy_id;
                  }
                  _this3.$emit('creat', postdata);
                } catch (error) {
                  console.log(error);
                  _this3.loading = false;
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  mounted: function mounted() {},

  watch: {
    'config.visible': function configVisible(val) {
      if (val) {
        this.setName();
      }
    },
    'config.requestLoading': function configRequestLoading(val) {
      if (!val) {
        this.loading = false;
      }
    }
  }
};